import { createContext, useState, useContext, useEffect } from 'react';
import companySettingsService from 'services/companySettingsService';
import { isAuthenticated } from 'services/api';

const FeaturesContext = createContext(null);

export const FeaturesProvider = ({ children }) => {
  const [enabledFeatures, setEnabledFeatures] = useState({
    time_tracking: true,
    vacation_tracking: true
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFeatures = async () => {
      // Only try to load features if user is authenticated
      if (!isAuthenticated()) {
        setLoading(false);
        return;
      }

      try {
        const features = await companySettingsService.getEnabledFeatures();
        setEnabledFeatures(features);
      } catch (error) {
        console.error('Failed to load enabled features:', error);
        // Default to all features enabled if we can't load settings
        setEnabledFeatures({
          time_tracking: true,
          vacation_tracking: true
        });
      } finally {
        setLoading(false);
      }
    };

    loadFeatures();
  }, []);

  const refreshFeatures = async () => {
    if (!isAuthenticated()) {
      return;
    }

    try {
      const features = await companySettingsService.getEnabledFeatures();
      setEnabledFeatures(features);
    } catch (error) {
      console.error('Failed to refresh enabled features:', error);
    }
  };

  return <FeaturesContext.Provider value={{ enabledFeatures, loading, refreshFeatures }}>{children}</FeaturesContext.Provider>;
};

export const useFeatures = () => {
  const context = useContext(FeaturesContext);
  if (!context) {
    throw new Error('useFeatures must be used within a FeaturesProvider');
  }
  return context;
};
